<template>
  <vs-row>
    <vs-alert class="vx-col" v-if="requests.length === 0">{{
      $t('messages.no_request_to_confirm')
    }}</vs-alert>
    <div class="vx-col py-3 w-full mb-base" :key="index" v-for="(req, index) in requests">
      <vx-card card-border no-shadow>
        <div slot="no-body">
          <open-street-map
            class="responsive card-map-top"
            view-only
            :markers="[{ latlng: [req.address.location.lat, req.address.location.lon] }]"
          />
        </div>
        <vs-row class="mb-base">
          <h4 class="mr-2">{{ $t(`users.genders.name.${req.gender}`) }} {{ req.lastName }}</h4>
          <p>{{ req.age | age_range }}</p>
        </vs-row>
        <vs-row class="mb-base">
          <div class="vx-col w-full"><address-string :address="req.address" /></div>
        </vs-row>
        <vs-row class="mb-base">
          <div class="vx-col w-full">
            <vs-row>
              <div class="font-semibold mr-2">{{ $t('request_forms.for_when') }}:</div>
              <div v-if="req.date">{{ req.date | datetime }}</div>
              <div v-else>{{ $t('request_forms.for_now') }}</div>
            </vs-row>
          </div>
        </vs-row>
        <vs-row>
          <vs-table hoverFlat :data="req.items" class="w-full" v-if="services">
            <template slot="thead">
              <vs-th>{{ $t('request_forms.service_name') }}</vs-th>
              <vs-th>{{ $t('request_forms.price') }} </vs-th>
              <vs-th>{{ $t('request_forms.number_of_service') }} </vs-th>
              <vs-th>{{ $t('request_forms.total_price') }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <tbody v-if="data.length">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>
                    {{ $t(`health_services.${req.subject}.${tr.service}`) }}
                  </vs-td>
                  <vs-td>
                    {{ services[req.subject][tr.service].price | persian_digits }}
                  </vs-td>
                  <vs-td> {{ tr.count | persian_digits }} {{ $t(`units.${tr.unit}`) }} </vs-td>
                  <vs-td>
                    {{ (services[req.subject][tr.service].price * tr.count) | persian_digits }}
                  </vs-td>
                </vs-tr>
              </tbody>
              <tfoot>
                <vs-tr class="font-semibold">
                  <vs-td></vs-td>
                  <vs-td></vs-td>
                  <vs-td class="text-right">{{ $t('invoices.total') }}:</vs-td>
                  <vs-td>{{
                    req.items.reduce(
                      (accum, item) => accum + services[req.subject][item.service].price * item.count,
                      0
                    ) | persian_digits
                  }}</vs-td>
                </vs-tr>
              </tfoot>
            </template>
          </vs-table>
        </vs-row>
        <div slot="footer">
          <vs-row vs-justify="flex-end">
            <vs-button
              icon-pack="feather"
              icon="icon-check"
              type="border"
              color="success"
              size="small"
              class="mr-2"
              @click="prepareForAccept(req)"
            >
              {{ $t('button.accept') }}
            </vs-button>
            <vs-button
              icon-pack="feather"
              icon="icon-x"
              type="border"
              color="danger"
              size="small"
              @click="rejectRequest(req, index)"
            >
              {{ $t('button.reject') }}
            </vs-button>
          </vs-row>
        </div>
      </vx-card>
    </div>
    <vs-popup
      :active="activeTimePopup"
      @close="activeTimePopup = false"
      :title="
        isConsulting(selectedRequest)
          ? $t('messages.please_set_proposed_time')
          : $t('messages.please_set_time')
      "
    >
      <date-picker
        type="datetime"
        v-model="startTime"
        :min="$moment().format()"
        :jump-minute="5"
        element="start-time"
      />
      <vs-input
        name="start-time"
        :value="
          $moment(startTime)
            .locale($vs.rtl ? 'fa' : 'en')
            .format('HH:mm dddd, DD MMMM YYYY')
        "
        id="start-time"
        v-validate="'required'"
        :label="isConsulting(selectedRequest) ? $t('services.proposed_time') : $t('services.start_time')"
        :data-vv-as="isConsulting(selectedRequest) ? $t('services.proposed_time') : $t('services.start_time')"
        class="w-full rf-input"
      />
      <template v-if="isReservation(selectedRequest)">
        <date-picker
          type="datetime"
          v-model="endTime"
          :min="startTime"
          :max="
            $moment(startTime)
              .add(1, 'day')
              .format()
          "
          :jump-minute="5"
          element="end-time"
        />
        <vs-input
          name="end-time"
          :value="
            $moment(endTime)
              .locale($vs.rtl ? 'fa' : 'en')
              .format('HH:mm dddd, DD MMMM YYYY')
          "
          id="end-time"
          v-validate="'required'"
          :label="$t('services.end_time')"
          :data-vv-as="$t('services.end_time')"
          class="w-full rf-input"
        />
      </template>
      <!-- <template v-else>
        <date-picker
          type="time"
          v-model="startTime"
          :min="$moment().format()"
          :max="
            $moment()
              .add(1, 'hour')
              .format()
          "
          :initial-value="$moment().format()"
          :jump-minute="5"
          element="start2-time"
        />
        <vs-input
          name="start2-time"
          :value="
            $moment(startTime)
              .locale($vs.rtl ? 'fa' : 'en')
              .format('HH:mm')
          "
          id="start2-time"
          v-validate="'required'"
          :label="$t('services.proposed_time')"
          :data-vv-as="$t('services.proposed_time')"
          class="w-full rf-input"
        />
      </template> -->
      <vs-row vs-justify="flex-end">
        <vs-button
          icon-pack="feather"
          icon="icon-check"
          color="success"
          class="mt-3"
          @click="acceptRequestWithTime"
        >
          {{ $t('button.confirm') }}
        </vs-button>
      </vs-row>
    </vs-popup>
  </vs-row>
</template>

<script>
import AddressString from '@/views/components/maps/AddressString'
import OpenStreetMap from '@/views/components/maps/OpenStreetMap'
import moduleReserve from '@/store/reserve/moduleReserve.js'

export default {
  name: 'RequestsList',
  components: { OpenStreetMap, AddressString },
  data() {
    return {
      requests: [],
      services: null,
      activeTimePopup: false,
      activeReserveTimePopup: false,
      startTime: this.$moment().format(),
      endTime: this.$moment().format(),
      selectedRequest: null
    }
  },
  methods: {
    isConsulting: request => request?.category === 'consulting',
    isReservation: request => !!request?.date,
    prepareForAccept(request) {
      this.selectedRequest = request
      if (this.isReservation(request) || this.isConsulting(request)) {
        if (this.isReservation(request)) {
          this.startTime = this.$moment(request.date).format()
          this.endTime = this.$moment(request.date)
            .add(1, 'hour')
            .format()
        } else {
          this.startTime = this.$moment().format()
        }
        this.activeTimePopup = true
      } else this.acceptRequest()
    },
    async acceptRequest() {
      const data = { ResultOfNurseConfirmation: 'yes' }
      let reserveTestPass = true

      if (this.isReservation(this.selectedRequest)) {
        data.ResultOfNurseConfirmationWithDate = {
          startDate: this.startTime,
          endDate: this.endTime
        }

        const testRes = await this.$store.dispatch(
          'reserve/testReserve',
          data.ResultOfNurseConfirmationWithDate
        )

        if (testRes.status !== 201) {
          reserveTestPass = false
        }
      }
      if (!reserveTestPass) return

      if (this.isConsulting(this.selectedRequest)) data.ProposedTime = this.startTime

      this.$store
        .dispatch('request/updateRequestBySubject', {
          category: this.selectedRequest.category,
          subject: this.selectedRequest.subject,
          id: this.selectedRequest.id,
          activity: 'ResultOfNurseConfirmation',
          data
        })
        .then(res => {
          this.selectedRequest = null
          this.activeTimePopup = false
          this.$router
            .push({ name: 'employee-invoice-view', params: { id: res.data.invoiceId } })
            .catch(() => {})
        })
    },
    acceptRequestWithTime() {
      this.$validator.validateAll().then(result => {
        if (result) this.acceptRequest()
      })
    },
    rejectRequest(request, index) {
      this.$store
        .dispatch('request/updateRequestBySubject', {
          category: request.category,
          subject: request.subject,
          id: request.id,
          activity: 'ResultOfNurseConfirmation',
          data: { ResultOfNurseConfirmation: 'no' }
        })
        .then(() => {
          this.requests.splice(index, 1)
        })
    }
  },
  async created() {
    this.$vs.loading()

    if (!moduleReserve.isRegistered) {
      this.$store.registerModule('reserve', moduleReserve)
      moduleReserve.isRegistered = true
    }

    this.$store
      .dispatch('request/fetchHealthRequests', { query: { status: 'pending' }, sort: { created_at: -1 } })
      .then(res => {
        this.requests = JSON.parse(
          JSON.stringify(
            res.data.filter(
              r =>
                r.services.findIndex(
                  s =>
                    s.employeeUserId === this.$store.state.AppActiveUser.id &&
                    s.isTaken &&
                    s.status === 'pending'
                ) > -1
            )
          )
        )
      })
      .finally(() => this.$vs.loading.close())

    this.services = this.$store.getters['config/provinceServiceDetails']
  }
}
</script>

<style>
.card-map-top {
  overflow: hidden;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
</style>
